import { render, staticRenderFns } from "./OrdersChart.vue?vue&type=template&id=09f5d0c2&scoped=true&"
import script from "./OrdersChart.vue?vue&type=script&lang=js&"
export * from "./OrdersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5d0c2",
  null
  
)

export default component.exports